import React from "react";

import DropdownSelect from "../../../FormElement/DropdownSelect";
import { FeatureNames } from "../types/featureNames";

interface IFeatureSelectProps {
  feature: FeatureNames;
  onChange: (feature: FeatureNames) => void;
}

const FeatureSelect: React.FunctionComponent<IFeatureSelectProps> = (props) => {
  return (
    <DropdownSelect
      value={props.feature}
      items={Object.values(FeatureNames)}
      onChange={props.onChange}
    />
  );
};

export default FeatureSelect;
